var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.413086 7.45579L4.41274 10.7485V8.27898H11.6121V6.63261H4.41274V4.16307L0.413086 7.45579Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21289 0.0463463C8.267 0.0436474 7.32998 0.234123 6.45613 0.606738C5.58228 0.979353 4.78896 1.5267 4.12213 2.21707L5.25323 3.38105C6.31074 2.29281 7.71702 1.69271 9.21289 1.69271C10.7088 1.69271 12.115 2.29281 13.1726 3.38105C14.2301 4.4693 14.8132 5.91645 14.8132 7.4558C14.8132 8.99515 14.2301 10.4423 13.1726 11.5305C12.115 12.6188 10.7088 13.2189 9.21289 13.2189C7.71702 13.2189 6.31074 12.6188 5.25323 11.5305L4.12213 12.6945C5.48121 14.0939 7.28906 14.8652 9.21289 14.8652C11.1367 14.8652 12.9446 14.0939 14.3037 12.6945C15.6635 11.2959 16.4131 9.43555 16.4131 7.4558C16.4131 5.47605 15.6635 3.61566 14.3037 2.21707C13.6368 1.5267 12.8435 0.979353 11.9697 0.606738C11.0958 0.234123 10.1588 0.0436474 9.21289 0.0463463Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.567d6d74.svg";
export { ForwardRef as ReactComponent };